import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useParams,
} from "react-router-dom";

import NotFound from "../NotFound";
// import {FailedPaymentScreen, SuccessPaymentScreen} from "./screens";
//import FindTransactionContainer from "./screens/FindTransactionScreen/Container";
import { SubTabs } from "../../components";
import {
  COMPANY_OTHER_TABS,
  FINANCIAL_SUB_TABS,
  FINANCIAL_SUB_TABS_ADMIN,
} from "../../values/subTabs";
import { useEffect, useState } from "react";
import { ITopMenuItem } from "../../types/common.interface";
import FinancialGroupContainer from "./screens/UploadDocument/Container";
import "./index.scss";
import UploadDocumentContainer from "./screens/UploadDocument/Container";
import Cookies from "js-cookie";
import constants from "../../values/constants";
import utils from "../../utils";

const CompanyOtherScreen = () => {
  const navigate = useNavigate();

  const param = useParams()["*"];

  const [selectedTab, setSelectedTab] = useState<ITopMenuItem>();

  function onTabClick(tab: any) {
    navigate(tab.pathname);
    setSelectedTab(tab);
  }

  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );

  useEffect(() => {
    setSelectedTab(
      COMPANY_OTHER_TABS.find((item) => item.pathname === param) as ITopMenuItem
    );
  });

  return (
    <section id="setting-screen">
      <SubTabs
        tabs={COMPANY_OTHER_TABS}
        onClick={onTabClick}
        selected={selectedTab as ITopMenuItem}
      />
      <Routes>
        <Route path="/" element={<Navigate to={"upload-document"} />} />
        <Route path="/upload-document" element={<UploadDocumentContainer />} />
        <Route path="/*" element={<NotFound />} />
      </Routes>
    </section>
  );
};

export default CompanyOtherScreen;
